/**
 * The placeholders a brand date pattern may contain.
 *
 * The vocabulary is dayjs's, because dayjs is what the api formats with
 * (`apps/api/src/shared/datetime/`) — but only its **date** half. A time is not
 * expressible here on purpose: `brand.timeFormat` is its own setting with its
 * own 12h/24h choice, and a pattern that also printed a time would render one
 * the product had already decided to render differently.
 *
 * **Ordered longest-first, and that order is load-bearing**: both the scanner in
 * `formatDatePattern` and the `DatePatternSchema` regex try the alternatives in
 * sequence, so `YY` listed before `YYYY` would consume half of every year.
 */
export const DATE_PATTERN_TOKENS = [
  'YYYY',
  'YY',
  'MMMM',
  'MMM',
  'MM',
  'M',
  'dddd',
  'ddd',
  'DD',
  'D',
] as const;

export type DatePatternToken = (typeof DATE_PATTERN_TOKENS)[number];

/**
 * Anything between brackets is copied out verbatim — dayjs's own escape, kept
 * so a pattern stays portable between the two formatters that read it.
 */
export const DATE_PATTERN_ESCAPE = { open: '[', close: ']' } as const;
